import { useGetFaireAcademyPageState } from "@faire/deprecated-retailer-visitor-shared/hooks/openWithFaire/useGetFaireAcademyPageState";
import { OWF_SECTION_NAME } from "@faire/deprecated-retailer-visitor-shared/views/open-with-faire/OpenWithFaireFaireAcademyLandingPage/types";
import { trackOpenWithFaireGuidesLandingPageCtaClick } from "@faire/web-api--source/events/openWithFaire/click/guidesLandingPageCta";
import openWithFaireAcademy from "@faire/web-api--source/routes/www/open-with-faire/academy";
import { Button, ButtonProps } from "@faire/web/slate/Button";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import styled from "styled-components";

export const ExploreAllGuidesButton: React.FC<Pick<ButtonProps, "variant">> = ({
  variant,
}) => {
  const { pageState } = useGetFaireAcademyPageState();
  return (
    <ResponsiveButton
      linkTo={openWithFaireAcademy()}
      onClick={() =>
        trackOpenWithFaireGuidesLandingPageCtaClick(
          pageState,
          OWF_SECTION_NAME.MASTER_FUNDAMENTALS
        )
      }
      variant={variant}
    >
      <StrictLocalMsg
        id="CQ3byO"
        defaultMessage="Explore all guides"
        description={{
          text: "CTA to explore all Faire Academy guides about opening a new business",
          img: "https://cdn.faire.com/fastly/e3db4eb1a40b5543d8da45b88007219c4415c68f679fcfa6a98eeb89d2711424.png",
        }}
      />
    </ResponsiveButton>
  );
};

const ResponsiveButton = styled(Button)`
  ${responsiveMediaQueries.tabletAndAbove} {
    max-width: fit-content;
  }
`;
